import React, { Component } from 'react';
import CurrencyValue from './currencyValue';
import ChangeValue from './changeValue';
import { DropdownMultiple } from 'reactjs-dropdown-component';
import http from "../services/httpService";
import config from "../config.json";
import Cookies from 'universal-cookie';
import $ from 'jquery';
import ReactDOM from "react-dom";
import { SortableContainer, SortableElement, arrayMove,sortableHandle,} from "react-sortable-hoc";
import { Table, Column, defaultTableRowRenderer } from "react-virtualized";


const SortableTable = SortableContainer(Table, { withRef: true });
const SortableTableRowRenderer = SortableElement(defaultTableRowRenderer);

const DragHandle = sortableHandle(() => <span>::</span>);

class FavoriKur extends Component {

  _cellRenderer = {
    Cursor: ({ rowData }) => <table><tr><td><DragHandle /></td></tr></table>,
    Kod: ({ rowData }) => <table><tr>{this.showCode(rowData)}</tr></table>,
    Alis: ({ rowData }) => <table><tr><CurrencyValue id={'buy' + rowData.Kod} value={rowData.Alis}/></tr></table>,
    Satis: ({ rowData }) => <table><tr><CurrencyValue id={'sell' + rowData.Kod} value={rowData.Satis}/></tr></table>,
    Change: ({ rowData }) => <table><tr><ChangeValue value={ rowData.Change} /></tr></table>
  };
  
  _handleSort = ({ oldIndex, newIndex }) => {

    const cookies = new Cookies();
    var idListCurrency = cookies.get('Favories');
    if(idListCurrency !== undefined){
      idListCurrency = arrayMove(idListCurrency, oldIndex, newIndex)
      cookies.set('Favories', idListCurrency, { path: '/', maxAge: 315360000  });
    }
    
    this.setState(prevState => ({
      
      values: arrayMove(prevState.values, oldIndex, newIndex),
      ids:idListCurrency
    }));
  };
  
  _rowGetter = ({ index }) => {
    return this.state.values[index];
  };
  
  _rowRenderer = props => {
    return <SortableTableRowRenderer {...props} />;
  };

  constructor(props) {
    super(props);
    this.dropdownCodesRef = React.createRef();

    this.state = {  
      values: [],
      header: this.props.header,
      showdescription: this.props.showdescription,
      currencies: [],
      ids:[],
      ddInitiliazed : false,
      tablewidth: 200,
      rowHeight: 63,
      useDragHandle : true
      }
    }

    componentDidMount() {
      this.setLabels();
      this.getCookies();
      const top = this;

      window.addEventListener('keydown', this.tabKeyPressed);
      window.addEventListener('mousedown', this.mouseClicked);

      window.$ = $;
        $(".zmdi-settings").on('click', function(event){
              $(".fav-settings").toggle(200);
              $(".ReactVirtualized__Table__headerColumn:first-child").toggle(200);
              $(".ReactVirtualized__Table__rowColumn:first-child").toggle(200);

              top.setState({useDragHandle:!top.state.useDragHandle})
          });

        $("body").on('DOMNodeRemoved', ".dd-wrapper", function(e) {
          if (e.target.classList.contains("dd-list")){ 
            $(".fav-settings").hide(200);
            $(".ReactVirtualized__Table__headerColumn:first-child").hide(200);
              $(".ReactVirtualized__Table__rowColumn:first-child").hide(200);
              top.setState({useDragHandle:true})
          }
        });


        $(window).on('resize',function(){
          var tablewidth = $('.table-responsive').width();

          var wWidth = window.innerWidth;
          var rowHeight = 63;
          if(wWidth < 630){
            rowHeight = 50;
          }

          top.setState({tablewidth,rowHeight})

        });
    }


    componentDidUpdate(prevProps) {
      if (this.props.values !== prevProps.values && Array.isArray(this.props.values)) 
      {
        var newValues = [];
        this.state.ids.forEach(id => {
          var newValue = this.props.values.filter( (value) => id === value.Id.toString());
          newValues = newValues.concat(newValue);
        });
        
        var tablewidth = $('.table-responsive').width();

        var wWidth = window.innerWidth;
        var rowHeight = 63;
        if(wWidth < 630){
          rowHeight = 50;
        }

        this.setState({values : newValues,tablewidth,rowHeight})
      }
    }

    tabKeyPressed = (e) => {
      if (e.keyCode === 9) {
        document.querySelector('body').classList.remove('noFocus');
        window.removeEventListener('keydown', this.tabKeyPressed);
        window.addEventListener('mousedown', this.mouseClicked);
      }
    }
  
    mouseClicked = () => {
      document.querySelector('body').classList.add('noFocus');
      window.removeEventListener('mousedown', this.mouseClicked);
      window.addEventListener('keydown', this.tabKeyPressed);
    }

    async setLabels(){
      allList = []
      if(JSON.parse(localStorage.getItem('allcurrencies')) !== null){
        this.setState({currencies:JSON.parse(localStorage.getItem('allcurrencies'))});
        allList = JSON.parse(localStorage.getItem('allcurrencies'));
      }
      else{
        var {data : currencies} =  await http.get(config.apiEndpoint + 'Labels/1');
        var {data : golds} =  await http.get(config.apiEndpoint + 'Labels/2');
        var allList = currencies.concat(golds);
        localStorage.setItem('allcurrencies', JSON.stringify(allList));
        this.setState({currencies: allList})
      }

      var selectedCodeList = allList.filter( (value) => this.state.ids.indexOf(value.value) !== -1)

      setTimeout(() => {
        this.dropdownCodesRef.current.selectMultipleItems(selectedCodeList);
        setTimeout(() => {
          this.setState({ddInitiliazed: true})
        }, 1000)
      }, 1000)

  }

  getCookies(){
      const cookies = new Cookies();

      var idListCurrency = cookies.get('Favories');
      if(idListCurrency === undefined){
        idListCurrency = ['1','3','4','20','21'];
        cookies.set('Favories', idListCurrency, { path: '/', maxAge: 315360000  });
      }
      this.setState({ids:idListCurrency})
  }

    showCode = tag =>{
      var windowWidth = document.body.clientWidth;
      if(tag['DataGroup'] === 1){
        if (this.props.showdescription && (windowWidth < 630 || (windowWidth <1340 && windowWidth > 992)) === false){
          var aciklama = ''
          if(tag['Aciklama'])
            aciklama = '(' + tag['Aciklama'] + ')'
          return <td>{tag['Kod']} <span>{aciklama}</span></td>;
        }
        else
          return <td>{tag['Kod']}</td>;
      }
      else{
          return <td>{tag['MobilAciklama']} <span>{tag['Aciklama']}</span></td>;
      }
    }


    onChange = (item, name) => {
     

      if (this.state.ddInitiliazed){ 
        var ids = []
        for( var i = 0; i < item.length; i++ ){
          ids.push(item[i].value);
        }

        const cookies = new Cookies();
        var idListCurrency = cookies.get('Favories');

        let resultA = idListCurrency.filter(elm => ids.map(elm => JSON.stringify(elm)).includes(JSON.stringify(elm)));
        let resultB = ids.filter(elm => !idListCurrency.map(elm => JSON.stringify(elm)).includes(JSON.stringify(elm)));  

        ids = resultA.concat(resultB);
        cookies.set('Favories', ids, { path: '/' , maxAge: 315360000 });

        this.setState({ids})

      }
    }


    render() { 

        return <div className="card">
          <div className="card-header fav-settings" style={{display:'none'}}>
            <div className="card-action">
            <span>Sürükle bırak yaparak sıralayabilirsiniz.</span>
            <DropdownMultiple
              name="currency"
              ref={this.dropdownCodesRef}
              title="Kurlar"
              titleSingular="favori kur"
              titlePlural="favori kur"
              list={this.state.currencies}
              onChange={this.onChange}
              styles={{
                wrapper:{ width: 170, paddingRight:10},
                headerTitle: { color: 'white', fontSize: '1.0rem' },
                header:{ backgroundColor: '#2e2a26'},
                headerArrowUpIcon: { borderColor: 'white'},
                headerArrowDownIcon: { fill: 'white'},
                list:{ backgroundColor: '#2e2a26'},
                listSearchBar:{ backgroundColor: '#2e2a26',color: 'white', fontSize: '1.0rem'},
                listItem:{ fontWeight: 400, fontSize:'1rem'},
                scrollList:{ backgroundColor: '#2e2a26'},
              }}
            />
          </div></div>
          <div className="card-body">
            <div className="card-box">
                <div className="table-responsive">
                <SortableTable
                    getContainer={wrappedInstance =>
                      ReactDOM.findDOMNode(wrappedInstance.Grid)
                    }
                    width={this.state.tablewidth}
                    height={this.state.rowHeight * this.state.values.length + 70}
                    rowRenderer={this._rowRenderer}
                    rowGetter={this._rowGetter}
                    rowHeight={this.state.rowHeight}
                    headerHeight={this.state.rowHeight}
                    rowCount={this.state.values.length}
                    data={this.state.values}
                    onSortEnd={this._handleSort}
                    useDragHandle={this.state.useDragHandle}
                  >
                    <Column
                      label=""
                      dataKey="Kod"
                      flexGrow={1}
                      cellRenderer={this._cellRenderer.Cursor}
                    />
                    <Column
                      label={this.state.header}
                      dataKey="Kod"
                      flexGrow={1}
                      cellRenderer={this._cellRenderer.Kod}
                    />
                    <Column
                      label="Alış"
                      dataKey="Alis"
                      cellRenderer={this._cellRenderer.Alis}
                    />
                    <Column
                      label="Satış"
                      dataKey="Satis"
                      cellRenderer={this._cellRenderer.Satis}
                    />
                     <Column
                      label={<i className="zmdi zmdi-settings zmdi-hc-lg"></i>}
                      dataKey="Change"
                      cellRenderer={this._cellRenderer.Change}
                    />
                  </SortableTable>
                </div>
            </div>
          </div>
        </div>;
    }   
}


export default FavoriKur;